import { CLAIM, VICTIM } from 'containers/data-structure';
import messages from 'containers/PreOpeningPage/messages';
import { get } from 'lodash';
import { OTHER_PROFESSION } from 'containers/RecapManagerPage/constants';
import validate from 'containers/services/validateForm';
import * as featureService from 'features/fflip-helpers';

import {
  INJURY_POST,
  VICTIM_ITT_AVAILABILITY,
} from 'containers/PreOpeningPage/constants';
import { FEATURES } from 'features/features';
export const victimConstraints = (victim: any) => {
  return {
    [VICTIM.CIN]: {
      presence: true,
      format: {
        pattern: /[A-Za-z]{1,2}\d{1,6}[A-Za-z]?|\d{1,7}[A-Za-z]/,
        message: messages.cinInvalid,
      },
    },
    [VICTIM.ADDRESS]: {
      presence: true,
    },
    [VICTIM.CITY]: {
      presence: true,
    },
    [VICTIM.CLASS_KEY]: {
      presence: true,
    },
    [VICTIM.DATE_OF_BIRTH]: {
      presence: true,
    },
    [VICTIM.FIRST_NAME]: {
      presence: true,
    },
    [VICTIM.INJURY_POST_KEY]: {
      presence: true,
    },
    [VICTIM.LAST_NAME]: {
      presence: true,
    },
    [VICTIM.OPPOSITION]: {
      presence: true,
    },
    [VICTIM.PROCEDURE_ID]: {
      presence: true,
    },
    [VICTIM.PROFESSION]: {
      presence:
        String(get(victim, [VICTIM.PROFESSION_TYPE])) === OTHER_PROFESSION,
    },
    [VICTIM.PROFESSION_TYPE]: {
      presence: true,
    },
    [VICTIM.QUALITY_KEY]: {
      presence: true,
    },
    [VICTIM.TELEPHONE_NUMBER]: {
      presence: true,
      format: {
        pattern: /^\d{10}$/,
        message: messages.phoneNumberInvalid,
      },
    },
    [VICTIM.ITT]: {
      presence:
        !INJURY_POST.DECEASED.includes(
          String(get(victim, [VICTIM.INJURY_POST_KEY])),
        ) &&
        String(get(victim, [VICTIM.ITT_AVAILABILITY])) ===
          VICTIM_ITT_AVAILABILITY.AVAILABLE,
    },
    [VICTIM.WORK_ACCIDENT_ID]: {
      presence: true,
    },
    [VICTIM.IS_EXCLUDED]: {
      presence: featureService.hasFeature(
        FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE,
      ),
    },
    [VICTIM.GENDER]: {
      presence: INJURY_POST.DECEASED.includes(
        String(get(victim, [VICTIM.INJURY_POST_KEY])),
      ),
    },
  };
};

export const claimCircumstancesConstraints = () => {
  return {
    [CLAIM.RESPONSABILITY_SHARE]: {
      presence: true,
    },
    [CLAIM.ACCIDENT_DESCRIPTION]: {
      presence: true,
    },
    [CLAIM.SCALE_CASE_KEY]: {
      presence: true,
    },
    [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: {
      presence: true,
    },
    [CLAIM.RESPONSABILITY_KEY]: {
      presence: true,
    },
  };
};

export const claimCircumstancesValidator = (claim: any) => {
  return validate(claim, claimCircumstancesConstraints());
};

export const victimValidator = (victim: any) => {
  return validate(victim, victimConstraints(victim));
};
